import { createTheme } from '@mui/material/styles';

/**
 * Einheitliches PLS-Theme — Teal auf Anthrazit, kein Indigo/Lila.
 */
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#0f766e',
      dark: '#0d5c56',
      light: '#14b8a6',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#334155',
      contrastText: '#ffffff',
    },
    error: {
      main: '#b91c1c',
    },
    success: {
      main: '#15803d',
    },
    warning: {
      main: '#a16207',
    },
    background: {
      default: '#eef1f4',
      paper: '#ffffff',
    },
    text: {
      primary: '#0f172a',
      secondary: '#475569',
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: '"Source Sans 3", "Segoe UI", Helvetica, Arial, sans-serif',
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
    h1: { fontWeight: 700 },
    h2: { fontWeight: 700 },
    h3: { fontWeight: 650 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
        containedPrimary: {
          backgroundColor: '#0f766e',
          '&:hover': { backgroundColor: '#0d5c56' },
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 10,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        rounded: {
          borderRadius: 10,
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: 'var(--table-head-bg)',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 650,
          color: 'var(--text-primary)',
          borderBottom: '1px solid var(--border-color)',
        },
      },
    },
  },
});

export default theme;
